<template>
  <div class="guide_page_">
    <div class="con_">
      <div class="flex_">
        <span class="icon_"></span>该产品请登录PC端投保
      </div>
      <div class="block_">
        <span>PC端网址为：yutai365.com</span>
        <span v-clipboard:copy="'yutai365.com'"
        v-clipboard:success="firstCopySuccess"
        v-clipboard:error="firstCopyError">点击复制</span>
      </div>
      <p class="pro_">推荐使用Google &360浏览器登录，登录账号密码与保思一致。如忘记密码可在保思公众号上<span class="red_">“我的-我的工具-修改密码”</span>或保思PC端(
      <span class="" v-clipboard:copy="'https://nyboss.yutai365.com/login'"
        v-clipboard:success="firstCopySuccess"
        v-clipboard:error="firstCopyError">https://nyboss.yutai365.com/login</span>)修改</p>

    </div>
    <div class="con_1" v-if="imgUrl">
      <img :src="imgUrl" alt="" class="img_">
    </div>
  </div>
</template>
<script>
import api from '@/utils/api'
export default {
  data () {
    return {
      imgUrl: ''
    }
  },
  mounted () {
    const { pcOrCpsPosterUrl } = this.$route.query
    this.imgUrl = !pcOrCpsPosterUrl || pcOrCpsPosterUrl == 'undefined' ? '' : pcOrCpsPosterUrl
    // if (!pcOrCpsPosterUrl || pcOrCpsPosterUrl == 'undefined') {
    //   this.$toast('海报不存在，请联系客服重新获取')
    // }
  },
  methods: {
    firstCopySuccess (e) {
      this.$toast('复制成功!')
    },
    firstCopyError (e) {
      this.$toast('复制失败,请手动长按复制地址！')
    }
  }
}
</script>
<style lang="scss" scoped>
.guide_page_{
  background-color:#fff;
  min-height:100vh;
  // padding-bottom: 10px;
  .con_{
    padding:20px 18px;
    .flex_{
      display:flex;
      align-items:center;
      font-size:16px;
      color:#333333;
      font-weight:bold;
      .icon_{
        width:17px;
        height:17.5px;
        display:inline-block;
        margin-right:10px;
        background:url(../../../assets/image/bs-2.0/icon_pc.png) center center no-repeat;
        background-size:100% 100%;
      }
    }
    .block_{
      background-color:#F8F8F8;
      border-radius:10px;
      padding:18px 20px;
      display:flex;
      align-items:center;
      justify-content:space-between;
      margin-top:10px;
      span:first-child{
        font-size:13px;
        color:#333333;
        font-weight:bold;
      }
      span:last-child{
        font-size:13px;
        color:#CCCCCC;
      }
    }
    .pro_{
      font-size:11px;
      color:#999999;
      text-align:left;
      line-height:18px;
      margin-top:10px;
      .red_{
        color:#FF4E3E;
      }
    }
  }
  .con_1{
    padding:0px 18px;
  }
  .img_{
    vertical-align: top;
    width:100%;
    height:auto;
  }
}
</style>
